import { __assign } from '../../../../../_externals/.pnpm/tslib@2.7.0/node_modules/tslib/tslib.es6.js';
import * as React from 'react';
import { useController } from 'react-hook-form';
import { FormLabel, LoadingInput, FormHint } from '../Form.styles.js';
import { SelectInputWrap } from './SelectInput.styles.js';

var isArrayOfObjects = function (arr) {
    return Array.isArray(arr) && arr.every(function (item) { return typeof item === "object"; });
};
var SelectInput = function (_a) {
    var name = _a.name, label = _a.label, placeHolder = _a.placeHolder, values = _a.values, _b = _a.showError, showError = _b === void 0 ? true : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.loading, loading = _d === void 0 ? false : _d;
    var _e = useController({
        name: name,
    }), field = _e.field, fieldState = _e.fieldState;
    return (React.createElement(SelectInputWrap, { "aria-label": name, disabled: disabled, hasError: Boolean(fieldState.error) },
        label && React.createElement(FormLabel, { htmlFor: name }, label),
        loading ? (React.createElement(LoadingInput, { "aria-label": "".concat(name, "-loading") })) : (React.createElement("select", __assign({ disabled: disabled, "aria-label": "".concat(name, "-select"), id: name }, field),
            (placeHolder || label) && (React.createElement("option", { value: "", disabled: true }, placeHolder || label)),
            isArrayOfObjects(values)
                ? values.map(function (_a) {
                    var value = _a.value, label = _a.label;
                    return (React.createElement("option", { key: value, value: value }, label));
                })
                : values.map(function (value) { return (React.createElement("option", { key: value, value: value }, value)); }))),
        fieldState.error && showError && (React.createElement(FormHint, { error: true }, fieldState.error.message))));
};

export { SelectInput };
//# sourceMappingURL=SelectInput.js.map
